/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEscalationTicketComments} from '../api'

 export const useQueryGetEscalationTicketComments = createReactQueryHook('getEscalationTicketComments', getEscalationTicketComments)
